import React, { useEffect, useState } from "react";
import { DashboardLayout, FormParser } from "../Components";
import { NavLink,useParams } from "react-router-dom";
import Masters from "../Components/masters.json"
import "./Pages.css"
import axiosConfig from "../Service/axiosConfig"
const RoleEdit = () => {
    const MastersModal=Masters.Role
    const formSubmit=(Data)=>{
        axiosConfig.put(`/account/roleview/${id}/`,Data).then(res=>{
                   console.log(res)
        }).catch(error=>{
            console.log(error)
        })
      }
    let { id } = useParams();
    const [Data, SetData] = useState([])
    console.log(Data.role_name)
    const GetData = async () => {
        try {
            const responce = await axiosConfig.get(`/account/roleview/${id}/`)
            SetData(responce.data)
        }
        catch (error) {
            console.log(error)
        }

    }
    useEffect(() => {
        GetData();
    }, [])
    return (
        <>
            <DashboardLayout>
                <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">Edit Role {id}</h5>
                    <NavLink to="/dashboard/masters/role" ><button className="btn btn-white">Manage</button></NavLink>
                </div>
                <FormParser modelObject={MastersModal} formData={Data} formSubmit={formSubmit}/>
            </DashboardLayout>
        </>
    )

}
export {RoleEdit}